(() => {
  window.addEventListener('DOMContentLoaded', () => {

    document.querySelectorAll('.section.--lined-motion').forEach( $section => {

      if ($section.getAttribute('id') === 'homeRequest') return;
      const $slogan = $section.querySelector('.__slogan');
      const desc = $section.querySelector('.__desc');
      const $bgImg = $section.querySelector('.__bg img');
      const $motionEl = $section.querySelector('.__motion');
      const $line1 = $section.querySelector('.__line1');
      const $line2 = $section.querySelector('.__line2');
      const $rect = $section.querySelector('.__rect');
      const $overlay = $section.querySelector('.__bg .__overlay');



      // 접근성을 위한 간소화된 초기화
      if (window.prefersReducedMotion) {
        // 애니메이션 비활성화 시 즉시 표시
        $motionEl.style.clipPath = 'none';
        $motionEl.style.webkitClipPath = 'none';
        if ($overlay) $overlay.style.opacity = '0';
        return;
      }

      // 성능 최적화된 파라미터 계산
      const calculateParams = (() => {
        let cachedParams = null;
        let lastResize = 0;

        return () => {
          const now = Date.now();
          if (cachedParams && (now - lastResize) < 100) {
            return cachedParams;
          }

          try {
            const sectionRect = $section.getBoundingClientRect();
            const sloganRect = $slogan.getBoundingClientRect();

            cachedParams = {
              ww: window.innerWidth,
              wh: window.innerHeight,
              height: $motionEl.clientHeight,
              cy: sloganRect.y - sectionRect.y + (sloganRect.height / 2),
              lh: sloganRect.height,
              DIFF: 30
            };

            lastResize = now;
            return cachedParams;
          } catch (error) {
            console.warn('Parameter calculation failed:', error);
            return {
              ww: window.innerWidth,
              wh: window.innerHeight,
              height: 600,
              cy: 300,
              lh: 60,
              DIFF: 30
            };
          }
        };
      })();

      let params = calculateParams();

      // 리사이즈 핸들러 최적화
      let resizeTimeout;
      const handleResize = () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          params = calculateParams();
          try {
            onComplete(); // 애니메이션 완료 상태로 설정
          } catch (error) {
            console.warn('Resize handling failed:', error);
          }
        }, 150);
      };

      window.addEventListener('resize', handleResize, { passive: true });

      // 클론 생성 (에러 핸들링 포함)
      try {
        const __descClone = desc.cloneNode(true);
        __descClone.classList.add('--clone');
        $section.prepend(__descClone);
      } catch (error) {
        console.warn('Clone creation failed:', error);
      }

      // 애니메이션 완료 함수
      function onComplete() {
        try {
          $motionEl.style.clipPath = 'none';
          $motionEl.style.webkitClipPath = 'none';
        } catch (error) {
          console.warn('Animation completion failed:', error);
        }
      }

      // 애니메이션 시작 함수
      function onStart() {
        try {
          gsap.set($line1, {
            attr: {
              d: `M 0 ${params.cy - params.lh} L 0 ${params.cy - params.lh} L ${-params.DIFF} ${params.cy} L 0 ${params.cy} Z`
            }
          });
          gsap.set($line2, {
            attr: {
              d: `M ${params.ww} ${params.cy} L ${params.ww + params.DIFF} ${params.cy} L ${params.ww} ${params.cy + params.lh} L ${params.ww} ${params.cy + params.lh} Z`
            }
          });
          gsap.set($rect, {
            attr: {
              d: `M 0 ${params.cy} L ${params.ww} ${params.cy} L ${params.ww} ${params.cy} L 0 ${params.cy} Z`
            }
          });
        } catch (error) {
          console.warn('Animation start failed:', error);
        }
      }




      // 메인 애니메이션 타임라인
      let motion = null;

      try {
        motion = gsap.timeline({
          paused: true,
          onStart: onStart,
          onComplete: onComplete
        })
            .to($overlay, {
              duration: 2,
              opacity: 0
            }, 0.5)
            .fromTo($bgImg,
                { scale: 3 },
                {
                  scale: 1,
                  duration: 3.5,
                  ease: 'power2.out'
                }, 0)
            .to($line1, {
              attr: {
                d: () => `M 0 ${params.cy - params.lh} L${params.ww + params.DIFF} ${params.cy - params.lh} L ${params.ww} ${params.cy} L 0 ${params.cy} Z`
              },
              duration: 1,
              ease: 'circ.inOut'
            }, 0)
            .to($line2, {
              attr: {
                d: () => `M ${params.ww} ${params.cy} L${0} ${params.cy} L ${-params.DIFF} ${params.cy + params.lh} L ${params.ww} ${params.cy + params.lh} Z`
              },
              duration: 1,
              ease: 'circ.inOut'
            }, 0)
            .to($rect, {
              attr: {
                d: () => `M 0 0 L ${params.ww} 0 L ${params.ww} ${params.height} L 0 ${params.height} Z`
              },
              duration: 1.6,
              ease: 'power2.out'
            }, 0.8)


        motion.timeScale(1.4);

      } catch (error) {
        console.warn('Timeline creation failed:', error);
      }

      // ScrollTrigger 설정
      try {
        // 메인 애니메이션 트리거
        ScrollTrigger.create({
          trigger: $section,
          start: 'top 80%',
          end: 'top top',
          once: true,
          onEnter: () => {
            if (motion) {
              motion.play();
            }
            // 리사이즈 시 애니메이션 완료 상태로 설정
            const resizeHandler = () => onComplete();
            window.addEventListener('resize', resizeHandler, { once: true, passive: true });
          }
        });

        // 패럴랙스 스크롤 트리거
        ScrollTrigger.create({
          trigger: $section.querySelector('.__bg'),
          start: 'top bottom',
          end: 'bottom top',
          onUpdate: (self) => {
            try {
              const progress = self.progress;
              gsap.set($bgImg, {
                objectPosition: `50% ${100 - (progress * 100)}%`
              });
            } catch (error) {
              console.warn('Parallax update failed:', error);
            }
          }
        });

      } catch (error) {
        console.warn('ScrollTrigger setup failed:', error);
      }

    })


  });
})();